import { render, staticRenderFns } from "./PurchaseInvoiceDisplayView.vue?vue&type=template&id=17b708d1"
import script from "./PurchaseInvoiceDisplayView.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports